import { Notifications } from "@mantine/notifications"
import { useRegisterSW } from "virtual:pwa-register/react"
import { Router } from "./-components/Router"
import { useViewportHeight } from "./utils/useViewportHeight"

export function App() {
  useRegisterSW({
    onRegisterError(error) {
      console.error("SW registration error", error)
    },
  })
  useViewportHeight()

  return (
    <>
      <Notifications />
      <Router />
    </>
  )
}
